function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4199",
  "data-name": "Path 4199",
  d: "M27.083,16.7a1.537,1.537,0,0,0-1.424,2.124L21.1,23.069a1.529,1.529,0,0,0-1.315-.186l-1.457-1.836a1.538,1.538,0,1,0-2.908-.7,1.55,1.55,0,0,0,.026.228l-3.678,2.884a1.592,1.592,0,1,0,.645.85l3.556-2.789c.01.008.017.019.026.026a1.544,1.544,0,0,0,1.551.226l1.4,1.765a1.524,1.524,0,0,0-.239.808,1.54,1.54,0,1,0,3.081,0,1.525,1.525,0,0,0-.061-.406l4.66-4.336a1.519,1.519,0,0,0,.7.175,1.541,1.541,0,1,0,0-3.081ZM10.945,25.235a.474.474,0,1,1,.475-.474.474.474,0,0,1-.475.474Zm5.718-4.515a.473.473,0,1,1,.632-.035h0A.535.535,0,0,1,16.663,20.721Zm3.584,4.1a.474.474,0,0,1-.288-.85l.007,0h0a.464.464,0,0,1,.281-.093.475.475,0,0,1,0,.948Zm6.836-6.109a.474.474,0,1,1,.459-.474A.474.474,0,0,1,27.083,18.715Z",
  transform: "translate(-9.405 -16.701)",
  fill: "#f6c244"
});

var SvgChart = function SvgChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.219,
    height: 9.602,
    viewBox: "0 0 19.219 9.602",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart.5a54e5a7.svg";
export { ForwardRef as ReactComponent };